import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import ClientRevenueReport from 'components/featured/Reports/ClientRevenueReport';

const RevenueTab = () => {
    const { id } = useParams<{ id: string }>();

    return (
      <Box 
        sx={{ 
          width: '100%', 
          height: 'calc(100vh - 180px)', 
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          p: 0 
        }}
      >
        <Box sx={{ 
          flexGrow: 1, 
          width: '100%',
          height: '100%',
          '& div': {
            height: '850px', 
            minHeight: '850px',
          },
          '& iframe': {         
            width: '100%',
            height: '100%',
            border: 'none' 
          },
          border: 'none',
          boxShadow: 'none' 
        }}>
          <ClientRevenueReport 
            reportName="Report - Client Revenue" 
            clientId={id} 
          />
        </Box>
      </Box>
    );
};

export default RevenueTab;